import {useStyles} from '@wix/tpa-settings/react'
import {WIDGET_TYPE} from '@wix/wix-events-commons-statics'
import React from 'react'
import stylesParams from '../../../stylesParams'
import {FeaturedList} from './featured-list/featured-list'
import List from './list'

export const ListLayout = () => {
  const {get} = useStyles()
  const featuredWidget = get(stylesParams.widgetType) === WIDGET_TYPE.FEATURED

  return featuredWidget ? <FeaturedList /> : <List />
}
